export const getTipLinkUrl = (buildEnv) => {
    switch (buildEnv) {
        case "production":
            return "https://tiplink.io";
        case "staging":
            return "https://staging.tiplink.io";
        case "development":
            return "https://dev.tiplink.io";
        case "adapter":
            return "https://adapter.tiplink.io";
        case "local":
            return "http://localhost:3000";
    }
};
export function getCloseButtonUrl(buildEnv) {
    const logoUrl = new URL("adapter-popup-close-icon.svg", getTipLinkUrl(buildEnv));
    return logoUrl.toString();
}
//# sourceMappingURL=utils.js.map